const HashesHash = (props) => {
  const hash = props?.row?.original?.hash || "-";

  return <span title={hash}>{hash}</span>;
};

export default HashesHash;
